module.exports = __webpack_public_path__ + "static/media/coin.6a4f0704.svg";